export default __webpack_public_path__ + "static/media/car lifting machine.0f1629eb.webp";